import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { api } from "../lib/api";
import { useContent } from "../context/ContentContext";

export default function Contact() {
  const { p } = useContent();
  const c = p("contact");
  const [params] = useSearchParams();
  const prefill = params.get("prefill") || "";
  const topic = params.get("topic") || null;
  const [form, setForm] = useState({ name: "", email: "", message: prefill });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", { ...form, topic });
      setSent(true);
      toast.success("Message sent — thank you.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 min-h-[60vh]" data-testid="contact-page">
      <Seo title="Contact — CaminoSapiens" description="Get in touch with the CaminoSapiens studio about etchings, commissions, and shipping." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />
      <p className="overline mb-4">{c.header.eyebrow}</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">{c.header.heading}</h1>
      <p className="text-[#4A4947] mt-6 leading-relaxed">
        {c.header.body}
      </p>

      {sent ? (
        <div className="mt-12 border border-[#E4E1DB] bg-[#F0EFEA] p-8" data-testid="contact-success">
          <p className="font-display text-2xl">{c.success.heading}</p>
          <p className="text-[#4A4947] mt-2">{c.success.body}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-12 space-y-6" data-testid="contact-form">
          <input required placeholder={c.form.name_placeholder} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className="w-full border-b border-[#1C1B1A] bg-transparent py-3 text-sm outline-none" />
          <input required type="email" placeholder={c.form.email_placeholder} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className="w-full border-b border-[#1C1B1A] bg-transparent py-3 text-sm outline-none" />
          <textarea required rows={5} placeholder={c.form.message_placeholder} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className="w-full border border-[#E4E1DB] bg-transparent p-3 text-sm outline-none focus:border-[#1C1B1A]" />
          <button type="submit" disabled={sending} data-testid="contact-submit" className="bg-[#1C1B1A] text-[#F9F8F6] px-8 py-4 text-sm hover:bg-[#B35D4B] transition-colors disabled:opacity-50">
            {sending ? c.form.sending_label : c.form.submit_label}
          </button>
        </form>
      )}
    </div>
  );
}
